import Axios from 'axios';
import router from '@/router/index'
import {appLoginUtil} from '@/common/js/userCtrl';

//允许携带cookie信息
Axios.defaults.withCredentials = true;
// ajax 响应拦截
Axios.interceptors.response.use(
    config => {
  
      if([10011,10012,10014].includes(config.data.status)){
        router.push({path:'/error'});
      }

      if([10010,10013].includes(config.data.status)){
        let appStr = sessionStorage.getItem("appJson");
        appLoginUtil(appStr)
      }
  
      return config;
    },
    error => {
      return Promise.reject(error.response);
    }
);
window.$ajax = Axios;



// WEBPACK FOOTER //
// ./src/common/js/axios.js